<script>
    import "firebase/firestore";
    import { getContext } from 'svelte';

    import { Collection } from "sveltefire";

    import LocationCard from './LocationCard.svelte';
    import Loading from './Loading.svelte';
    import Fallback from './Fallback.svelte';
    import { organizationSets } from '../stores';

    const firebase = getContext('firebase').getFirebase();

    let query = (ref) => ref.where('setID', 'in', $organizationSets).orderBy(firebase.firestore.FieldPath.documentId()).limit(10);

    function nextPage(last) {
        if (!last) {
            query = (ref) => ref.where('setID', 'in', $organizationSets).orderBy(firebase.firestore.FieldPath.documentId()).limit(10);
            return;
        }
        query = (ref) => ref.where('setID', 'in', $organizationSets).orderBy(firebase.firestore.FieldPath.documentId()).startAfter(last.id).limit(10);
    }

    function prevPage(first) {
        if (!first) {
            query = (ref) => ref.where('setID', 'in', $organizationSets).orderBy(firebase.firestore.FieldPath.documentId()).limit(10);
            return;
        }
        query = (ref) => ref.where('setID', 'in', $organizationSets).orderBy(firebase.firestore.FieldPath.documentId()).endBefore(first.id).limitToLast(10);
    }

    function toStart() {
        query = (ref) => ref.where('setID', 'in', $organizationSets).orderBy(firebase.firestore.FieldPath.documentId()).limit(10);
    }
</script>

<Collection path={'locations'} {query} let:data={locations} let:ref={locationsRef} let:last let:first>
    <div class="wrapper">
        {#if locations && locations.length > 0}
            <div class="nav">
                <input type="button" value="Prev" on:click={() => prevPage(first)}>
                <input type="button" value="Next" on:click={() => nextPage(last)}>
            </div>
            {#each locations as location}
                {#if !location.unpublished}
                    <LocationCard 
                        id={location.id}
                        title={location.title}
                        showTitle={location.showTitle}
                        description={location.description}
                        showDescription={location.showDescription}
                        directLink={location.directLink}
                        lat={location.lat}
                        lng={location.lng}
                        mapVisible={location.mapVisible}
                        location={location}
                    />
                {/if}
            {/each}
            <div class="nav">
                <input type="button" value="Prev" on:click={() => prevPage(first)}>
                <input type="button" value="Next" on:click={() => nextPage(last)}>
            </div>
        {:else}
            <h3>You've reached the end.</h3>
            <input type="button" value="Back to Start" on:click={() => toStart()}>
        {/if}
    </div>

    <div slot="loading">
        <Loading />
    </div>

    <div slot="fallback">
        <Fallback />
    </div>
</Collection>

<style>
    .wrapper {
        margin: 0px 0px;
    }

    h3 {
        margin: 15px;
    }

    input[type=button] {
        font-size: 18px;
        font-weight: 700;
        border: 3px solid white;
        border-radius: 25px;
        padding: 5px 12px 4px 12px;
        margin: 0px 10px;
        background-color: transparent;
        color: white;
        -webkit-transition: all var(--fast);
        transition: all var(--fast);
    }

    input[type=button]:disabled {
        border-color: var(--grey);
        color: var(--white);
    }

    input[type=button]:hover {
        cursor: pointer;
        background-color: white;
        color: var(--primary);
        box-shadow: var(--box-shadow);
    }

    input[type=button]:focus {
        background-color: white;
        color: var(--primary);
        box-shadow: var(--box-shadow);
    }
</style>
